import React, { Component } from 'react';
import './Header.css';
import Navigation from '../Navigation/Navigation';

import { Link } from 'react-router';
import Callback from "../Callback/Callback";

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mode: "Default"
        };

        this.buttonsDesktop = [
            /*['welcome',"Willkommen"],*/
            {id: 'hotel', title: "Ihr Hotel"},
            {id: 'zimmer', title: "Zimmer"},
            {id: 'restaurant', title: "Restaurant"},
            {id: 'region', title: "Region"},
            {id: 'anfahrt', title: "Anfahrt"}
        ];

        this.buttonsMobile = [
            {id: 'home', title: "Willkommen"},
            {id: 'hotel', title: "Ihr Hotel"/*, buttons: [{id: 'zimmer', title: 'Zu den Zimmern'}]*/},
            {id: 'zimmer', title: "Zimmer"},
            {id: 'restaurant', title: "Restaurant"},
            {id: 'region', title: "Region"},
            {id: 'anfahrt', title: "Anfahrt"},
            {id: 'sonstiges', title: "Sonstiges", type: "button", buttons: [
                {id: 'kontakt', title: 'Kontakt', type: "button"},
                {id: 'jobs', title: 'Jobangebote', type: "button"},
                {id: 'impressum', title: 'Impressum', type: "button"},
                {id: 'datenschutz', title: 'Datenschutz', type: "button"},

            ]}
        ];


    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate() {

    };

    handleSetActive = (to) => {
        //console.log(("handleSetActive: " + to);
    }

    handleScroll = (event) =>  {
        // console.log(" - handleScroll: ");
        /*for (var k in event['currentTarget']) {
            //console.log(( k + " - event: : " + event['currentTarget'][k]);
        }*/

        //let scrollTop = document.documentElement.scrollTop;
        let scrollTop = event['currentTarget'].pageYOffset;

        if (scrollTop >= 0) {
            var y = 121;
            if (scrollTop < y && this.state.mode !== "Default") {
                this.setState({
                    mode: "Default"
                });
            } else if (scrollTop >= y && this.state.mode !== "Fix") {
                this.setState({
                    mode: "Fix"
                });
            }
        }
        // console.log(" - scrollTop: " + scrollTop + " mode: " + this.state.mode);

       /*
        this.setState({
            transform: itemTranslate
        });*/
    }

    onButtonClick = (type, id) =>  {
        if (typeof this.props.onButtonClick === 'function') {
            this.props.onButtonClick(type, id);
        }
    }


  render() {
        let callbackUrl = "";
      if (process.env.NODE_ENV !== "production") {
          callbackUrl = "https://landhotel-schorssow.de/php/callback.php";
      } else {
          callbackUrl = "https://landhotel-schorssow.de/php/callback.php";
      }

    return (
      <div className="Header">
          <div className={"NavigationContainer " + this.state.mode}>

              <div className="CallbackContainer">
                <Callback site={"https://landhotel-schorssow.de"} url={callbackUrl} />
                  <div style={{clear: "both"}}></div>
              </div>
              <div className="NavigationDesktop">

                  <div className="HeaderAddress">
                      <div className="HeaderAdressRow row">
                          <div className="ColAdress col-lg-3 col-md-3 col-sm-5 col-xs-5 ">
                              <h3>Adresse <i className="Icon material-icons">my_location</i></h3>
                              <p>
                                  Landhotel Schorssow<br/>Am Haussee 4<br/>17166 Schorssow
                              </p>
                          </div>
                          <div className="ColAdress col-lg-4 col-md-4 col-sm-7 col-xs-7">

                              <h3><i className="Icon material-icons">phone</i> Kontakt</h3>
                              <p>
                                  Tel: +49 3 99 33 / 7 06 45<br/>
                                  Fax: +49 3 99 33 / 7 03 27
                                  <div className="row-small hidden-lg hidden-md visible-sm visible-xs"><i className="Icon material-icons">mail_outline</i><a href="mailto:willkommen@landhotel-schorssow.de?subject=Kontaktaufnahme Landhotel Schorssow">willkommen@landhotel-schorssow.de</a></div>
                              </p>
                          </div>
                         <div className="ColAdress col-lg-5 col-md-5 hidden-sm hidden-xs">
                              <h3>Email &amp; Web<i className="Icon material-icons">mail_outline</i></h3>
                              <p>
                                  <a href="mailto:willkommen@landhotel-schorssow.de?subject=Kontaktaufnahme Landhotel Schorssow">willkommen@landhotel-schorssow.de</a>
                                  <br/>
                                  <a href="https://www.landhotel-schorssow.de">www.landhotel-schorssow.de</a>
                                  <br/>
                                  <a href="https://ferienhaus.landhotel-schorssow.de">ferienhaus.landhotel-schorssow.de</a>
                              </p>
                          </div>
                      </div>
                  </div>

                  <div className="FixCon">
                    <Navigation onBookingClick={this.props.onBookingClick} buttons={this.buttonsDesktop} className={"desktop " + this.state.mode}/>
                    <Link to="buchen" className="ButtonRight ButtonBuchen"><i className="Icon material-icons">hotel</i> Jetzt Zimmer buchen</Link>

                  </div>

              </div>

              <div className="NavigationMobile">
                  <div className="HeaderAddress">
                      <div className="HeaderAdressRow row">
                          <div className="ColAdress col-xs-12 ">
                              <p>
                                  <i className="Icon material-icons">my_location</i> Landhotel Schorssow<span className="mobileBreak">&nbsp;</span>Am Haussee 4, 17166 Schorssow
                              </p>
                          </div>
                          <div className="ColAdress col-xs-12">
                              <p>
                                  <a href="tel:+493993370645"><i className="Icon material-icons">phone</i> Tel: +49 3 99 33 / 7 06 45</a>&nbsp;
                                  <span className="mobileBreak">&nbsp;</span>Fax: +49 3 99 33 / 7 03 27
                              </p>
                          </div>
                          <div className="ColAdress col-xs-12">
                              <p>
                                  <a href="mailto:willkommen@landhotel-schorssow.de?subject=Kontaktaufnahme Landhotel Schorssow"><i className="Icon material-icons">mail_outline</i> willkommen@landhotel-schorssow.de</a>
                              </p>
                          </div>
                      </div>
                  </div>
                  <div className="FixCon BlackBg"></div>
              </div>

          </div>

          <Link
              to="willkommen"
              className={this.state.mode}
          >
              <div className="MainLogo"></div>
              <div className="MainLogoFix"></div>
          </Link>

          <div className="NavigationMobile">
              <div className="FixCon">

                  <Link to="buchen" className="ButtonRight ButtonBuchen"><i className="Icon material-icons">hotel</i> Jetzt Zimmer buchen</Link>
                  <Navigation onBookingClick={this.props.onBookingClick} buttons={this.buttonsMobile} className={"mobile " + this.state.mode} onButtonClick={this.onButtonClick}/>
              </div>

          </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js